import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '..'

const BusinessLoans = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <Path d="M23.478 10.263h-15.3l4.693 13.433h10.607V10.263Z" fill="#4175DF" />
    <Path d="M2.264 10.263H12.87v13.433H2.264V10.263Z" fill="#54A0FF" />
    <Path
      d="m9.867 8.265 3.004 4.092c0 1.677 1.345 3.036 3.004 3.036s3.003-1.359 3.003-3.036l3.004-4.092H9.867Z"
      fill="#ACCCFF"
    />
    <Path
      d="M18.878 8.265v4.092c0 1.677 1.345 3.036 3.004 3.036 1.66 0 3.004-1.359 3.004-3.036v-1.245l-6.008-2.847ZM3.86 8.265l3.003 4.092c0 1.677 1.345 3.036 3.004 3.036s3.004-1.359 3.004-3.036V8.265H3.859Z"
      fill="#257AD8"
    />
    <Path
      d="M.855 11.112v1.245c0 1.677 1.345 3.036 3.004 3.036 1.66 0 3.004-1.359 3.004-3.036V8.265L.855 11.112Z"
      fill="#ACCCFF"
    />
    <Path
      d="m3.917 2.252-3.062 8.86h6.008l3.004-4.43-1.473-4.43H3.918Z"
      fill="#CBDFFF"
    />
    <Path
      d="m24.886 11.112-3.062-8.86h-4.477l-1.472 4.43 3.003 4.43h6.008Z"
      fill="#338DEF"
    />
    <Path
      d="M17.347 2.252h-4.476l-3.004 4.43 3.004 4.43h6.007l-1.53-8.86Z"
      fill="#CBDFFF"
    />
    <Path d="m8.394 2.252-1.53 8.86h6.007v-8.86H8.394Z" fill="#338DEF" />
    <Path
      d="M23.179 8.736c-.367-.323-.792-.433-1.232-.163-.27.165-.587.19-.858.03a1.253 1.253 0 0 0-.642-.182c-.227 0-.444.064-.642.181-.271.16-.589.136-.858-.03-.44-.269-.865-.159-1.232.164-.575.506-.791 1.344-.094 2.53.498.847 1.167 1.37 1.718 1.414.296.37 1.92.37 2.216 0 .551-.045 1.22-.567 1.718-1.415.697-1.185.481-2.023-.094-2.529ZM22.638 13.867h-4.382S13.3 19.795 13.3 22.199c0 2.69 2.388 3.984 3.665 3.984h6.964c1.276 0 3.665-1.294 3.665-3.984 0-2.404-4.956-8.332-4.956-8.332Z"
      fill="#FFC839"
    />
    <Path
      d="M23.179 8.736c-.367-.323-.792-.433-1.232-.163a1.008 1.008 0 0 1-.086.047c.044.035.088.073.13.116.507.506.696 1.344.083 2.53-.438.847-1.026 1.37-1.511 1.414-.088.125-.31.208-.573.248.59.08 1.368-.002 1.565-.248.551-.045 1.22-.567 1.718-1.415.697-1.185.481-2.023-.094-2.529ZM22.638 13.867h-1.122s4.36 5.928 4.36 8.332c0 2.69-2.101 3.984-3.225 3.984h1.278c1.276 0 3.665-1.294 3.665-3.984 0-2.404-4.956-8.332-4.956-8.332Z"
      fill="#EAB540"
    />
    <Path
      d="M23.37 14.778c-.44-.562-.732-.911-.732-.911h-4.382s-.292.349-.733.91h5.848Z"
      fill="#EAB540"
    />
    <Path
      d="M22.053 18.16h-.6a1.605 1.605 0 0 0-.31-.692h.91a.34.34 0 0 0 .347-.334.34.34 0 0 0-.347-.334h-3.506a.34.34 0 0 0-.347.334.34.34 0 0 0 .347.334h1.217c.273 0 .53.103.723.289.12.115.206.253.254.404h-2.194a.34.34 0 0 0-.347.334.34.34 0 0 0 .347.334h2.18a1.066 1.066 0 0 1-1.006.693h-.72a.564.564 0 0 0-.51.308.525.525 0 0 0 .067.576l2.117 2.568a.354.354 0 0 0 .487.054.326.326 0 0 0 .056-.47l-1.953-2.368h.456c.85 0 1.56-.586 1.724-1.361h.608a.34.34 0 0 0 .347-.334.34.34 0 0 0-.347-.334Z"
      fill="#F0E9E6"
    />
    <Path
      d="M17.182 13.094c0 .427.346.773.773.773h4.984a.773.773 0 1 0 0-1.545h-4.985a.773.773 0 0 0-.772.772Z"
      fill="#4974CC"
    />
    <Path
      d="M22.939 12.322h-1.088a.773.773 0 0 1 0 1.545h1.088a.773.773 0 1 0 0-1.545Z"
      fill="#3561BB"
    />
  </Svg>
)

export default BusinessLoans
